import { useEffect, useRef, useState } from "react";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
// hooks
import { usePostulacion } from "./usePostulacion";
import { useNavigate } from "react-router";
import { openNotification } from "../utils/Notifactions";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/reducers/index";
import DocumentosService from "../api/Documentos/api-documentos";
import { guardarDatosPostulacion } from "../redux/actions/participantesAction";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { useEncrypt } from "./useEncrypt";
import { ObjNotificaciones } from "../config/notificaciones";
import { documentosRescatados, fusionarDocumentos } from "../utils/fusionDocumentos";

export const useDocumentosAdministrativos = () => {
  // hooks
  const dispatch = useDispatch();
  const { decrypt } = useEncrypt();
  const [documentos, setDocumentos] = useState([]);
  /**
   * Las direcciones que se eliminaron en esta sesion. Sirven para que la
   * fusion previa al guardado no resucite un archivo que se quito a
   * proposito.
   */
  const urlsBorradas = useRef<string[]>([]);

  const [loading, setLoading] = useState(false);
  const { datos_postulacion } = useSelector(
    (state: RootState) => state.participantes
  );
  const { cargarPostulacionTipoParticipante } = usePostulacion();
  const _tipoParticipante = localStorage.getItem(
    "tipo_participante_postulacion"
  );
  //   route
  const navigate = useNavigate();
  //   redux variables

  const Administrativos = [
    {
      "id": 6,
      "idconvocatoria": "",
      "url_documento": "",
      "descripcion": "RUT",
      "subsanable": false,
      "obligatorio": false,
      "tipo_documento_id": 6,
      "tipo_persona": 0
    },
    {
      "id": 3,
      "idconvocatoria": "",
      "url_documento": "",
      "descripcion": "Cédula de ciudadanía",
      "subsanable": false,
      "obligatorio": false,
      "tipo_documento_id": 3,
      "tipo_persona": 0
    },
    {
      "id": 4,
      "idconvocatoria": "",
      "url_documento": "",
      "descripcion": "Declaración de Residencia",
      "subsanable": false,
      "obligatorio": false,
      "tipo_documento_id": 4,
      "tipo_persona": 0
    },
    {
      "id": 185,
      "idconvocatoria": "",
      "url_documento": "",
      "descripcion": "Registro Único Nacional de Agentes Culturales - SOY CULTURA",
      "subsanable": false,
      "obligatorio": false,
      "tipo_documento_id": 185,
      "tipo_persona": 0
    }]

  useEffect(() => {
    getDocumentos()
  }, []);

  const getDocumentos = async () => {
    const { data } = await apiConvocatorias.obtenerDocumentosAdministrativos(decrypt(localStorage.getItem('idConvocatoriaPostulacion')))
    const convocatoria_id = decrypt(localStorage.getItem('idConvocatoriaPostulacion'))

    if (data.documentos_administrativos) {
      let resp = data.documentos_administrativos.filter((x) => x !== null).map(
        (doc: any, index: number) => {
          return {
            id: doc.id,
            idconvocatoria: doc.idconvocatoria,
            descripcion: doc.descripcion,
            obligatorio: doc.obligatorio,
            subsanable: doc.subsanable,
            tipo_documento_id: doc.tipo_documento_id,
            tipo_persona: doc.tipo_persona,
            url_documento: doc.url_documento,
            url_participante: doc.url_participante,
          }
        }
      );

      let docs = resp.filter(
        (doc) => doc.tipo_persona === Number(_tipoParticipante)
      );

      if (convocatoria_id == 1391 || convocatoria_id == 1390 || convocatoria_id == 1388) {
        setDocumentos(Administrativos)
      } else {
        return setDocumentos(docs);
      }
    }
  };

  const guardarArchivosAdministrativos = async (
    datos: any,
    e: any,
    index: number
  ) => {
    if (e.target.files.length > 0) {
      let documento = e.target.files[0];
      if (documento.size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (documento.type !== "application/pdf") {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos PDF",
          placement: "bottomRight",
        });
      }
      const formData = new FormData();
      formData.append("archivo", documento);
      let data = await DocumentosService.guardarArchivo(formData);

      let nuevosdocumentos: any = documentos.map(
        (doc: any, indexdoc: number) => {
          if (index === indexdoc) {

            return {
              ...doc,
              url_participante: data.data,
            };
          }
          return {
            ...doc,
          };
        }
      );
      console.log(nuevosdocumentos);
      // En pantalla angosta los documentos son desplegables: no hay tarjeta
      // a la que quitarle el borde, y entrar por posicion reventaba.
      document
        .getElementsByClassName("cards-documentos")
      [index]?.classList.remove("border-error-cards-documentos");
      localStorage.setItem('documentos', JSON.stringify(nuevosdocumentos));
      setDocumentos(nuevosdocumentos);
      // Auto-guardado silencioso
      await consultarArchivos('silent', nuevosdocumentos);
      return;
    }
  };


  const guardarDeclaracion = async (
    index: number,
    datosDeclaracion?: {
      tipoPersona: string;
      paisResidencia: string;
      anosResidencia: string;
      direccion: string;
      pais: string;
      ciudad: string;
      comuna: string;
      firma: string;
      fechaFirma: string;
    }
  ) => {
    if (index >= 0 && documentos.length > 0) {
      // Buscar el documento por descripción "Declaración de Residencia"
      const docDeclaracion = documentos.find(
        (doc: any) => doc.descripcion === "Declaración de Residencia"
      );

      if (docDeclaracion) {
        let nuevosdocumentos: any = documentos.map(
          (doc: any) => {
            if (doc.id === docDeclaracion.id) {
              return {
                ...doc,
                // agregar aqui las variables del modal
                tipo_persona_declaracion: datosDeclaracion?.tipoPersona || "",
                pais_residencia: datosDeclaracion?.paisResidencia || "",
                anos_residencia: datosDeclaracion?.anosResidencia || "",
                direccion: datosDeclaracion?.direccion || "",
                pais: datosDeclaracion?.pais || "",
                ciudad: datosDeclaracion?.ciudad || "",
                comuna: datosDeclaracion?.comuna || "",
                firma_declaracion: datosDeclaracion?.firma || "",
                fecha_firma: datosDeclaracion?.fechaFirma || "",
              };
            }
            return {
              ...doc,
            };
          }
        );
        console.log(nuevosdocumentos);
        if (document.getElementsByClassName("cards-documentos")[index]) {
          document
            .getElementsByClassName("cards-documentos")
          [index].classList.remove("border-error-cards-documentos");
        }
        localStorage.setItem('documentos', JSON.stringify(nuevosdocumentos));
        setDocumentos(nuevosdocumentos);
        // Auto-guardado silencioso
        await consultarArchivos('silent', nuevosdocumentos);
        return;
      }
    }
  };


  const guardarDeclaracionP = async (
    index: number,
    datosDeclaracion?: {
      paisResidencia: string;
      anosResidencia: string;
      direccion: string;
      pais: string;
      ciudad: string;
      comuna: string;
      firma: string;
      fechaFirma: string;
      correo: string;
      telefono: string;
      tipo_documento: string;
    }
  ) => {
    if (index >= 0 && documentos.length > 0) {
      // Buscar el documento por descripción "Declaración de Residencia"
      const docDeclaracion = documentos.find(
        (doc: any) => doc.descripcion === "Declaración de Residencia"
      );

      if (docDeclaracion) {
        let nuevosdocumentos: any = documentos.map(
          (doc: any) => {
            if (doc.id === docDeclaracion.id) {
              return {
                ...doc,
                // agregar aqui las variables del modal
                pais_residencia: datosDeclaracion?.paisResidencia || "",
                anos_residencia: datosDeclaracion?.anosResidencia || "",
                direccion: datosDeclaracion?.direccion || "",
                pais: datosDeclaracion?.pais || "",
                ciudad: datosDeclaracion?.ciudad || "",
                comuna: datosDeclaracion?.comuna || "",
                firma_declaracion: datosDeclaracion?.firma || "",
                fecha_firma: datosDeclaracion?.fechaFirma || "",
                correo: datosDeclaracion?.correo || "",
                telefono: datosDeclaracion?.telefono || "",
                tipo_documento: datosDeclaracion?.tipo_documento || "",
              };
            }
            return {
              ...doc,
            };
          }
        );
        console.log(nuevosdocumentos);
        // En pantalla angosta los documentos son desplegables: no hay tarjeta
        // a la que quitarle el borde, y entrar por posicion reventaba.
        document
          .getElementsByClassName("cards-documentos")
        [index]?.classList.remove("border-error-cards-documentos");
        localStorage.setItem('documentos', JSON.stringify(nuevosdocumentos));
        setDocumentos(nuevosdocumentos);
        // Auto-guardado silencioso
        await consultarArchivos('silent', nuevosdocumentos);
        return;
      }
    }
  };


  const guardarRelacion = async (
    index: number,
    participantes: any
  ) => {
    if (index >= 0 && documentos.length > index) {
      const nuevosdocumentos: any = [...documentos];
      nuevosdocumentos[index] = {
        ...nuevosdocumentos[index],
        participantes: participantes,
        fecha_firma: new Date().toLocaleString("es-CO", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false
        }).replace(",", ""),
        datos_empresa: JSON.parse(localStorage.getItem('datosEmpresa') || '{}')
      };

      console.log('Actualizando Relación:', nuevosdocumentos[index]);

      const cardElements = document.getElementsByClassName("cards-documentos");
      if (cardElements[index]) {
        cardElements[index].classList.remove("border-error-cards-documentos");
      }

      localStorage.setItem('documentos', JSON.stringify(nuevosdocumentos));
      setDocumentos(nuevosdocumentos);
      // Auto-guardado silencioso
      await consultarArchivos('silent', nuevosdocumentos);
      return;
    }
  };


  const guardarCartaConformacion = async (
    index: number,
    participantes: any
  ) => {
    if (index >= 0 && documentos.length > index) {
      const nuevosdocumentos: any = [...documentos];
      nuevosdocumentos[index] = {
        ...nuevosdocumentos[index],
        participantes: participantes,
        fecha_firma: new Date().toLocaleString("es-CO", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false
        }).replace(",", "")
      };

      console.log('Actualizando Carta Conformación:', nuevosdocumentos[index]);

      const cardElements = document.getElementsByClassName("cards-documentos");
      if (cardElements[index]) {
        cardElements[index].classList.remove("border-error-cards-documentos");
      }

      localStorage.setItem('documentos', JSON.stringify(nuevosdocumentos));
      setDocumentos(nuevosdocumentos);
      // Auto-guardado silencioso
      await consultarArchivos('silent', nuevosdocumentos);
      return;
    }
  };

  const guardarDeclracionGC = async (
    index: number,
    participantes: any
  ) => {
    if (index >= 0 && documentos.length > index) {
      const nuevosdocumentos: any = [...documentos];
      nuevosdocumentos[index] = {
        ...nuevosdocumentos[index],
        participantes: participantes,
        fecha_firma: new Date().toLocaleString("es-CO", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false
        }).replace(",", "")
      };

      console.log('Actualizando Declaración GC:', nuevosdocumentos[index]);

      const cardElements = document.getElementsByClassName("cards-documentos");
      if (cardElements[index]) {
        cardElements[index].classList.remove("border-error-cards-documentos");
      }

      localStorage.setItem('documentos', JSON.stringify(nuevosdocumentos));
      setDocumentos(nuevosdocumentos);
      // Auto-guardado silencioso
      await consultarArchivos('silent', nuevosdocumentos);
      return;
    }
  };

  const eliminarArchivo = async (e: any, index: number, idDocAdmin: number) => {
    const borrada = documentos[index].url_participante;
    await DocumentosService.eliminarArchivo(borrada);
    if (borrada) urlsBorradas.current.push(borrada);
    let nuevosdocumentos: any = documentos.map((doc: any, indexdoc: number) => {
      if (idDocAdmin === doc.id) {
        return {
          ...doc,
          url_participante: "",
          fecha_firma: "",
          participantes: []
        };
      }
      return {
        ...doc,
      };
    });


    return setDocumentos(nuevosdocumentos);
  };

  /**
   * Lo que el servidor tiene guardado ahora mismo, para no escribir encima de
   * lo que esta copia no conoce.
   */
  const documentosDelServidor = async (id_postulacion: any) => {
    try {
      const respuesta: any = await apiParticipantes.consultarPostulacion(id_postulacion);
      const cuerpo = respuesta?.data ?? respuesta;
      const postulacion = Array.isArray(cuerpo) ? cuerpo[0] : cuerpo;
      return postulacion?.documentos_administrativos ?? [];
    } catch (error) {
      // Si no se puede releer, se sigue con lo que hay: es mejor guardar que
      // perder lo que la persona acaba de subir.
      console.error("No se pudo releer los documentos antes de guardar", error);
      return [];
    }
  };

  const consultarArchivos = async (mode?: boolean | 'silent', docsToSave?: any) => {
    const id_postulacion = decrypt(localStorage.getItem('id_postulacion'));
    const documentosDelCliente = docsToSave || documentos;

    try {
      setLoading(true);

      // El backend reemplaza la columna entera con lo que reciba, asi que
      // primero se mira que hay guardado y se fusiona.
      const enServidor = await documentosDelServidor(id_postulacion);
      const documentosASalvar = fusionarDocumentos(
        enServidor,
        documentosDelCliente,
        urlsBorradas.current
      );

      const rescatados = documentosRescatados(
        enServidor,
        documentosDelCliente,
        urlsBorradas.current
      );
      if (rescatados > 0) {
        console.warn(
          `Se conservaron ${rescatados} documento(s) que esta pantalla no tenia cargados.`
        );
      }

      // Eliminar el campo 'preview' de los participantes antes de enviar al API
      // para evitar el error 413 (Payload Too Large) causado por strings base64 largos.
      const documentosLimpios = documentosASalvar.map((doc: any) => {
        if (doc.participantes && Array.isArray(doc.participantes)) {
          return {
            ...doc,
            participantes: doc.participantes.map((p: any) => {
              const { preview, ...rest } = p;
              return rest;
            })
          };
        }
        return doc;
      });

      await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
        decrypt(localStorage.getItem("id_postulacion")),
        documentosLimpios
      );

      await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");

      dispatch(
        guardarDatosPostulacion({
          ...datos_postulacion,
          documentos_administrativos: documentosASalvar,
        })
      );
      setLoading(false);

      if (mode === 'silent') {
        return;
      }

      if (mode === true) {
        ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
        return navigate("/Usuario");
      } else {
        return navigate("/usuario/Documentostecnicos");
      }
    } catch (error) {
      setLoading(false);
      return console.error(error);
    }
  };


  return {
    Administrativos,
    guardarArchivosAdministrativos,
    cargarPostulacionTipoParticipante,
    documentos,
    setDocumentos,
    eliminarArchivo,
    consultarArchivos,
    loading,
    guardarDeclaracion,
    guardarDeclaracionP,
    guardarRelacion,
    guardarCartaConformacion,
    guardarDeclracionGC
  };
};
